import {
    DATASET_CLEAN_LONDON,
    DATASET_LPG_VLGC,
} from '_legacy/models/Datasets';

export const DefaultFixtureStatusMapping = [
    { id: 'S', gridDisplay: 'S', selectDisplay: 'S - ON SUBS' },
    { id: 'C', gridDisplay: 'C', selectDisplay: 'C - CONFIRMED' },
    { id: 'X', gridDisplay: 'X', selectDisplay: 'X - CANCELLED' },
    { id: 'F', gridDisplay: 'F', selectDisplay: 'F - FAILED' },
    { id: 'H', gridDisplay: 'H', selectDisplay: 'H - HOLD' },
];

export const statusesByDataset = (datasetId) => {
    switch (datasetId) {
        case DATASET_LPG_VLGC:
            return [
                ...DefaultFixtureStatusMapping,
                { id: 'T', gridDisplay: 'T', selectDisplay: 'T - TECH' },
            ].map((m) => m.id);
        default:
            return DefaultFixtureStatusMapping.map((m) => m.id);
    }
};

const CustomFixtureStatusMapping = {
    [DATASET_CLEAN_LONDON]: [
        { id: 'S', gridDisplay: 'SUB', selectDisplay: 'SUB - ON SUBS' },
        { id: 'C', gridDisplay: 'FXD', selectDisplay: 'FXD - FIXED' },
        { id: 'X', gridDisplay: 'CAN', selectDisplay: 'CAN - CANCELLED' },
        { id: 'F', gridDisplay: 'FLD', selectDisplay: 'FLD - FAILED' },
        { id: 'H', gridDisplay: 'HLD', selectDisplay: 'HLD - HOLD' },
    ],
    [DATASET_LPG_VLGC]: [
        ...DefaultFixtureStatusMapping,
        { id: 'T', gridDisplay: 'T', selectDisplay: 'T - TECH' },
    ],
};

export const DefaultTankTypeMapping = [
    { id: 'R', gridDisplay: 'FR', selectDisplay: 'Fully Refrigerated' },
    { id: 'I', gridDisplay: 'I', selectDisplay: 'Insulated' },
    { id: 'P', gridDisplay: 'P', selectDisplay: 'Pressurized' },
    { id: 'S', gridDisplay: 'SR', selectDisplay: 'Semi Refrigerated' },
];

export const FetchMappingSelectStatusDisplayValue = (value, datasetId) => {
    const mapping = FetchStatusMapping(value, datasetId);

    if (mapping) {
        return mapping.selectDisplay;
    }
    return value;
};

export const FetchMappingGridStatusDisplayValue = (value, datasetId) => {
    const mapping = FetchStatusMapping(value, datasetId);

    if (mapping) {
        return mapping.gridDisplay;
    }
    return value;
};

const FetchStatusMapping = (value, datasetId) => {
    const currentFixtureStatusMapping =
        CustomFixtureStatusMapping.hasOwnProperty(datasetId)
            ? CustomFixtureStatusMapping[datasetId]
            : DefaultFixtureStatusMapping;
    const searchMapping = currentFixtureStatusMapping.filter(
        (m) => m.id === value
    );
    if (searchMapping.length === 1) {
        return searchMapping[0];
    }
    return undefined;
};

export const FetchMappingSelectTankTypeDisplayValue = (value) => {
    const mapping = FetchTankTypeMapping(value);

    if (mapping) {
        return mapping.selectDisplay;
    }
    return value;
};

export const FetchMappingGridTankTypeDisplayValue = (value) => {
    const mapping = FetchTankTypeMapping(value);

    if (mapping) {
        return mapping.gridDisplay;
    }
    return value;
};

const FetchTankTypeMapping = (value) => {
    const searchMapping = DefaultTankTypeMapping.filter((m) => m.id === value);
    if (searchMapping.length === 1) {
        return searchMapping[0];
    }
    return undefined;
};
